module.exports = __webpack_public_path__ + "img/img_tc_2.686700e2.png";